/**
 * Lock the app's zoom on a phone (Phase 13).
 *
 * iOS Safari ignores the viewport's `user-scalable=no`, so pinch-zoom (the `gesture*` events)
 * and double-tap-to-zoom are blocked at the document level instead. The image lightbox does its
 * own zoom through touch events and is left alone.
 *
 * Controls are exempt from the double-tap guard. `preventDefault()` on a `touchend` is also what
 * cancels the click that touch would have produced, so for a year this guard swallowed every tap
 * that landed within 300ms of the one before it — ticking people off a contact list, a quick
 * second press on any button in the app. Controls carry `touch-action: manipulation` (index.css),
 * which is how WebKit itself turns double-tap-to-zoom off on them, so they need no guard.
 */
export const DOUBLE_TAP_MS = 300;
export const TAP_TARGETS = 'button, a, input, textarea, select, label, [role="button"], [role="option"], [role="tab"], [role="menuitem"], [role="checkbox"], [role="switch"], [contenteditable]';

export function installZoomGuard(doc = document, now = () => Date.now()) {
  ['gesturestart', 'gesturechange', 'gestureend'].forEach((ev) => {
    doc.addEventListener(ev, (e) => e.preventDefault(), { passive: false });
  });
  let lastTouchEnd = -Infinity;
  doc.addEventListener('touchend', (e) => {
    const t = now();
    const target = e.target && typeof e.target.closest === 'function' ? e.target : null;
    if (t - lastTouchEnd < DOUBLE_TAP_MS && target && !target.closest('.pr-lightbox') && !target.closest(TAP_TARGETS)) {
      e.preventDefault();
    }
    lastTouchEnd = t;
  }, { passive: false });
}
